export type SoccerPlayerId = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
export const soccerPlayerIdNumbers: SoccerPlayerId[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export type SoccerPlayerLabelType = "POS" | "NUM" | "o";
